import styles from './CarouselHeading.scss';

import cx from 'classnames';
import React from 'react';

import { ReferencedEntry } from 'contentful';
import { CarouselAssembly, CarouselType } from 'src/api/contentful/contentTypes.cloverdotcom';

import { Text } from 'src/components/Contentful/Text';

type HeadingProps = React.AllHTMLAttributes<HTMLDivElement> & {
  entry?: ReferencedEntry<CarouselAssembly>;
  carouselType?: CarouselType;
};
export const Heading: React.FC<HeadingProps> = ({
  entry, style, className, carouselType, ...props // Ignoring the styles that react-slick passes down
}) => (
  <div
    className={cx(className, styles.heading, {
      [styles.headingFeature]: carouselType === CarouselType.FEATURE,
      [styles.headingSquare]: carouselType === CarouselType.SQUARE,
      [styles.headingHero]: carouselType === CarouselType.HERO,
      })}
    {...props}
  >
    <Text tagName="h1" entry={entry} field="title" />
  </div>
);
